import React from 'react';
import BaseList from '@its/components/lib/Container components/ListContainer/BaseList';
import { getDepartments } from '../../api';
import { onSuccess } from './util';

export default class extends React.Component {

  static propTypes = {
    navigate: React.PropTypes.bool,
    buttonStyle: React.PropTypes.object,
  }

  static defaultProps = {
    navigate: true,
    buttonStyle: {},
  }

  constructor(props, context) {
    super(props, context);
    this.mapStateToProps = (state) => ({
      title: state.app.departments.list.title,
      columns: state.app.departments.list.columns,
      items: state.app.departments.list.items,
    });

    this.appBar = {
      title: 'DEPARTMENTS',
      navigateBack: false,
    };
  }

  render() {
    return (
      <BaseList
        mapStateToProps={this.mapStateToProps}
        route="department/add"
        appBar={this.appBar}
        request={getDepartments}
        onResult={onSuccess}
        buttonStyle={this.props.buttonStyle}
        navigate={this.props.navigate}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Department/DepartmentList.js
 **/